import React from "react";
import { Link } from "react-router-dom";
import Organizer from "components/organizer";
import { TFlooringVariation } from "../helpers/flooring-variation-types-helper";

interface IFlooringVariationOrganizerFieldProps
{
  variation: TFlooringVariation | undefined;
}

const FlooringVariationOrganizerField: React.FC<IFlooringVariationOrganizerFieldProps> = ({ variation }) =>
  variation?.relOrganizer?.id ? (
    <Link
      className="table-link-underline"
      to={`${Organizer.Const.basePath}/${variation.relOrganizer.id}`}
    >
      {variation.relOrganizer.title}
    </Link>
  ) : (
    <strong>&mdash;</strong>
  );

export default FlooringVariationOrganizerField;
